import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Map, List } from 'immutable';

import SportPriceLaddersForm from './SportPriceLaddersForm.jsx';
import { Popup } from 'src/components/Popup/Popup';
import CopyPricesForm from './copyPricesForm.jsx'

import Form from '../../Form';

class SportPriceLadders extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {};
    }

    onSave(e) {
        let { data } = this.state;
        let { onSave, sport } = this.props;

        if (e) {
            e.preventDefault();
        }

        let refs = Object.values(this.refs);
        let newLadder = refs.length && refs.map( ref => {
            //get state of the chids (forms) with prices
            let { data, errors } = ref.state;

            Form.prototype.onSubmit.call(ref, e);
            //check for validation error
            return (!errors.d && !errors.f && data.f && data.d ) && {...data, d: parseFloat(data.d)}
        }).filter( ref => ref);

        //if equal then no erros
        if(newLadder.length === refs.length){
            onSave && onSave(sport, {
                'prices' : newLadder
            })
        }
    }

    onCopyPopup(e) {
        if (e) {
            e.preventDefault();
        }

        this.setState({
            activeModal: true
        })
    }

    onClose() {
        this.setState({
            activeModal: false
        })
    }


    onCopy(sport) {
        let {onCopy, sport: target} = this.props;

        if (sport && target) {
            this.onClose()
            onCopy(target, {sport})
        }
    }

    render() {
        let { ladder, sportsNames, sport } = this.props;
        let { activeModal } = this.state;

        let copyModal = (
            <Popup
                title="Copy from"
                className="copy-from-modal"
                priority={ 1000 }
                active={ !!activeModal }
                onClose={ this.onClose.bind(this) }
            >
                <CopyPricesForm sports={sportsNames} onSubmit={this.onCopy.bind(this)}/>
            </Popup>
        );

        return (
            <section className="sport-ladder row">
                {copyModal}

                <div className="row">
                    <div className="col-4 header">
                        <div className="col-4">Decimal</div>
                        <div className="col-4">Fraction</div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-4">
                        {
                            ladder && ladder.get('prices', List()).map((price, idx) => {
                                let data = {
                                    d: price.get('d'),
                                    f: price.get('f'),
                                    enabled: price.get('enabled')
                                }

                                return <SportPriceLaddersForm ref={idx} data={data} key={idx}/>
                            })
                        }
                    </div>
                    <div className="col-8 buttons">
                        <a className="btn" href="#" onClick={ this.onSave.bind(this)}>Save</a>
                        <a className="btn" href="#" onClick={ this.onCopyPopup.bind(this)}>Copy from</a>
                    </div>
                </div>
            </section>
        )
    }
}

export default SportPriceLadders;
